import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook pour gérer les vues d'un véhicule
 */
export const useVehicleViews = (vehicleId: string) => {
  const queryClient = useQueryClient();

  // Récupérer le nombre de vues de la semaine
  const { data: weeklyViews, isLoading } = useQuery({
    queryKey: ['vehicle-views', vehicleId],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc('get_weekly_views', { vehicle_uuid: vehicleId });

      if (error) {
        console.error('Error fetching weekly views:', error);
        return 0;
      }

      return data || 0;
    },
    refetchInterval: 30000, // Rafraîchir toutes les 30 secondes
  });

  // Enregistrer une vue
  const recordViewMutation = useMutation({
    mutationFn: async () => {
      // Obtenir l'IP et user agent (côté client on a des limites)
      const userAgent = navigator.userAgent;

      const { error } = await supabase
        .from('vehicle_views')
        .insert({
          vehicle_id: vehicleId,
          user_agent: userAgent,
          ip_address: 'client', // Sera remplacé par l'edge function si nécessaire
        });

      if (error) throw error;
    },
    onSuccess: () => {
      // Invalider le cache pour rafraîchir le compteur
      queryClient.invalidateQueries({ queryKey: ['vehicle-views', vehicleId] });
    },
  });

  return {
    weeklyViews: weeklyViews || 0,
    isLoading,
    recordView: recordViewMutation.mutate,
  };
};
